import { render, staticRenderFns } from "./SupplierView.vue?vue&type=template&id=609f371a&"
import script from "./SupplierView.vue?vue&type=script&lang=ts&"
export * from "./SupplierView.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports